import {
  OfferingBrokerageOfferingsSearchRequestQuery,
  BrokerageOfferingsSearchRequestQuery,
  OfferingBrokerageOfferingRequestParams,
} from '@lio/api-types';
import { brokerageKeys } from '@services/brokerage';

export const offeringKeys = {
  offerings: () => [...brokerageKeys.brokerage, 'offerings'] as const,
  offeringSearch: (params: OfferingBrokerageOfferingsSearchRequestQuery) =>
    [...offeringKeys.offerings(), params] as const,
  brokerageOfferingsSearch: ['brokerageOfferings'] as const,
  brokerageOfferingsSearchWithParams: (brokerageId: string | undefined, params: BrokerageOfferingsSearchRequestQuery) =>
    ['brokerageOfferings', brokerageId, { ...params }] as const,
  offeringBrokerageOfferingSearch: ['offeringBrokerageOfferings'] as const,
  offeringBrokerageOfferingSearchWithParams: (
    params: OfferingBrokerageOfferingsSearchRequestQuery & OfferingBrokerageOfferingRequestParams,
  ) => [...brokerageKeys.brokerageOfferingsSearch, params] as const,
};
